export default {
  main: {
    light: "#F6417A",
    dark: "#00CCF1",
  },
  gray: {
    200: "#EFF1F5",
    400: "#9CA3AF",
    800: "#1D232F",
    900: "#101319",
  },
  white: "#FFF",
  black: "#000",
}
